import restProvider from './rest.provider'

// Define which resources use REST API
const restResources = [
    'StudentOrderHome',
    'StudentOrderSchool',
    'TeacherOrder',
    'BulkOrder',
    'ShippedStudentOrder',
    'printLogs' // Add printLogs to use REST if needed
]

const dataProvider = {
    ...restProvider,

    getList: (resource, params) => {
        if (restResources.includes(resource)) {
            return restProvider.getList(resource, params)
        } else {
            // For non-REST resources, return empty data
            return Promise.resolve({
                data: [],
                total: 0
            })
        }
    },

    create: (resource, params) => {
        if (restResources.includes(resource)) {
            return restProvider.create(resource, params)
        } else {
            // For non-REST resources, return success
            return Promise.resolve({
                data: { id: Date.now(), ...params.data }
            })
        }
    },

    update: (resource, params) => {
        if (restResources.includes(resource)) {
            return restProvider.update(resource, params)
        } else {
            return Promise.resolve({
                data: { id: params.id, ...params.data }
            })
        }
    },

    delete: (resource, params) => {
        if (restResources.includes(resource)) {
            return restProvider.delete(resource, params)
        } else {
            return Promise.resolve({
                data: { id: params.id }
            })
        }
    }
}

export default dataProvider